import { AppData, Img, Lightning, Log, Registry, Router } from '@lightningjs/sdk'
import { List } from '@lightningjs/ui'
import { AppSetup } from '../../lib/app-setup'
import OptionsMenuItem from '../../ui-elements/options-menu-item'
import GridViewModel, { FocusInfo } from '../../lib/components/grid/grid-view-model'
import { clearRecentlyWatched, fetchData } from '../../lib/models/data-service'
import { Logger } from '../../lib/logger'
import { Helper } from '../../lib/helper'
import { GRIDTYPE } from '../../lib/enum'
import { AppApiConfig } from '../../lib/app-api-config'
import { CloseButton } from '../../ui-elements/option-close-button'
import { Autoplay } from '../../lib/autoplay'
import RateContentWidget from './RateContentWidget'


export interface OptionsMenuWidgetTemplateSpec extends Lightning.Component.TemplateSpec {
    OptionsMenuList: List
    menuItems: any[]
    page: any
}

export default class OptionsMenuWidget
    extends Lightning.Component<OptionsMenuWidgetTemplateSpec>
    implements Lightning.Component<OptionsMenuWidgetTemplateSpec>
{

    OptionsMenuList = this.getByRef('OptionsMenuList')!
    menuItems: any[] = []
    index = -1
    page: any
    autoPlay!: Autoplay

    diableKeyHandling = false

    defaultItems = [
        { index: 14, id: 'rate-content', content: 'Rate This Content', page: ['main-grid-screen', 'mlp-grid-screen'], userlog: 'StarMenuOptions_RateContent' },
        { index: 0, id: 'add-queue', content: 'Add To Queue', page: ['main-grid-screen', 'mlp-grid-screen'], userlog: 'StarMenuOptions_AddToQueue' },
        { index: 14, id: 'clear-Single-Recent', content: 'Clear Content From Recently Watched', page: ['main-grid-screen'], userlog: 'StarMenuOptions_ClearContentFromRecentlyWatched' },
        { index: 1, id: 'remove-queue', content: 'Remove From Queue', page: ['main-grid-screen', 'mlp-grid-screen'], userlog: 'StarMenuOptions_RemoveFromQueue' },
        { index: 10, id: 'moreinfo', content: 'More Information About Selected Item', page: ['main-grid-screen', 'mlp-grid-screen'], userlog: 'StarMenuOptions_VideoMoreInfo' },
        { index: 2, id: 'my-queue', content: 'My Queue', page: ['main-grid-screen'], userlog: 'StarMenuOptions_GoToQueue' },
        { index: 3, id: 'similar-videos', content: 'Similar Videos', page: ['main-grid-screen', 'mlp-grid-screen'], userlog: 'StarMenuOptions_GoToSimilarVideos' },
        { index: 4, id: 'search', content: 'Search', page: ['menu', 'main-grid-screen', 'mlp-grid-screen'], userlog: 'StarMenuOptions_GoToSearch' },
        { index: 5, id: 'menu', content: 'Browse Menu', page: ['main-grid-screen'], userlog: 'StarMenuOptions_GoToSearch' },
        { index: 6, id: 'top', content: 'Go To Top Row', page: ['menu', 'main-grid-screen', 'mlp-grid-screen'], userlog: 'StarMenuOptions_GoToTopRow' },
        { index: 7, id: 'startItem', content: 'Go To First Item In This Row', page: ['main-grid-screen', 'mlp-grid-screen'], userlog: 'StarMenuOptions_GoToFirstItemInRow' },
        // { index: 8, id: 'clearrecent', content: 'Clear Recently Watched Content', page: ['main-grid-screen'], userlog: 'StarMenuOptions_ClearRecentlyWatched' },
        // { index: 9, id: 'about', content: 'About', page: ['menu', 'main-grid-screen', 'mlp-grid-screen'], userlog: 'StarMenuOptions_About' },
        { index: 10, id: 'block', content: 'Block Item', page: ['menu', 'main-grid-screen', 'mlp-grid-screen'], userlog: 'StarMenuOptions_Block' },
        { index: 11, id: 'unblock', content: 'Unblock Item', page: ['menu', 'main-grid-screen', 'mlp-grid-screen'], userlog: 'StarMenuOptions_Unblock' },
        { index: 12, id: 'parental-control', content: 'Parental Control', page: ['main-grid-screen', 'mlp-grid-screen'], userlog: 'StarMenuOptions_ParentalControl' },

        { index: 13, id: 'cc-setting', content: 'CC Setting', page: ['main-grid-screen', 'mlp-grid-screen'], userlog: 'StarMenuOptions_CCSetting' },
    ]


    static override _template(): Lightning.Component.Template<OptionsMenuWidgetTemplateSpec> {
        return {
            ...super._template(),
            w: 1920,
            h: 1080,
            alpha: 0,
            rect: true,
            color: 0x66000000,
            collision: true,
            flex: { direction: 'column', alignItems: 'center', justifyContent: 'center', margin: 20 },
            // { w: 300, h: 50, rect: true, color: 0xffffffff, flexItem: { margin: 10 }, Text: { w: (w) => w, text: { text: 'menu 1', textColor: 0xff000000, textAlign: 'center' } } },
            // { w: 300, h: 50, rect: true, color: 0xffffffff, flexItem: { margin: 10 }, Text: { w: (w) => w, text: { text: 'menu 2', textColor: 0xff000000, textAlign: 'center' } } },
            // { w: 300, h: 50, rect: true, color: 0xffffffff, flexItem: { margin: 10 }, Text: { w: (w) => w, text: { text: 'menu 3', textColor: 0xff000000, textAlign: 'center' } } },
            // { w: 300, h: 50, rect: true, color: 0xffffffff, flexItem: { margin: 10 }, Text: { w: (w) => w, text: { text: 'menu 4', textColor: 0xff000000, textAlign: 'center' } } },
            // { w: 300, h: 50, rect: true, color: 0xffffffff, flexItem: { margin: 10 }, Text: { w: (w) => w, text: { text: 'menu 5', textColor: 0xff000000, textAlign: 'center' } } },
            OptionsMenuPanel: {
                rect: true,
                autoResize: true,
                collision: true,
                color: 0x00000000,
                zIndex: 100,
                flex: { direction: 'column', alignItems: 'center', justifyContent: 'center' },
                Title: {
                    y: 20,
                    h: 50,
                    text: { text: 'OPTIONS', fontSize: 28, textColor: 0xddffffff, textAlign: 'center', fontFace: Helper.getFontFamily('Black') },
                },
                Line: {
                    y: 20,
                    w: 650,
                    h: 2,
                    rect: true,
                    color: 0xffffffff,
                },
                OptionsMenuList: {
                    w: 650,
                    h: 250,
                    autoResize: true,
                    type: List,
                    direction: 'column',
                    collision: true,
                    signals: { onIndexChanged: true },
                    wrap: false,
                    flexItem: { marginTop: 40, marginBottom: 40 },
                },
                CloseButton: {
                    w: 500,
                    h: 60,
                    collision: true,
                    type: CloseButton,
                    flexItem: { marginBottom: 30 },
                }
            },
            RateContentPanel: {
                w: 600,
                h: 180,
                type: RateContentWidget,
                visible: false,
                signals: { close: '_onRateContentClose' }
            }
        }
    }


    override _init() {
        this.tag('OptionsMenuList').children[0].collision = true
    }

    override _active() {
        const { appState } = AppData as AppSetup;
        const appApiConfig: AppApiConfig = appState?.getAppApiConfig()!;
        const bgcolor = Helper.getHexaColor(appApiConfig?.appLayoutConfig.bgcolor)

        this.tag('OptionsMenuPanel').patch({
            color: bgcolor,
            alpha: 0.9
        })
    }

    setFocusResetRow = (type) => {
        const { appState } = AppData as AppSetup
        const app = appState?.getApp()
        const currGrid: GridViewModel = app?.navigation.getCurrentGrid()!
        const videoInfo = app?.navigation.getCurrentVodInfo()
        let focusObj: FocusInfo = currGrid.getFocusInfo();
        if (type == 'top') {
            focusObj.focusRow = 0;
            focusObj.foucsItem = 0;
        } else if (type == 'startItem') {
            focusObj.foucsItem = 0;
        }
        currGrid.focusInfo = {
            focusRow: focusObj.focusRow,
            foucsItem: focusObj.foucsItem
        }
        this.page.resetFocus(focusObj)
    }


    $ItemSelected() {
        if(this.diableKeyHandling) return
        Log.info('OptionsMenuWidget: $ItemSelected: ', this.index, this.menuItems)
        const item = this.menuItems[this.index].item
        const { appState } = AppData as AppSetup
        const app = appState?.getApp()
        const videoInfo = app?.navigation.getCurrentVodInfo()
        let nodeType = 'video';
        let nodeId = videoInfo.node_id;
        let isMenuFocused = this.page.isMenuFocused;
        if (videoInfo.node_id == '') {
            nodeType = 'show';
            nodeId = videoInfo.id;
        }
        let likeValue = videoInfo.likedislike
        Logger.processUserAction(item.userlog, '');
        switch (item.id) {
            case 'startItem':
            case 'top':
                this.setFocusResetRow(item.id);
                this.page.widgets.menu.hideMenu()
                /* Fix for XFIN-1062 */
                if(!this.page.hasFocus()){
                    Router.focusPage();
                }
                /* Fix for XFIN-1062 */
                break;
            /* XFIN-1389 - Removed Clear Recently Watched from Options Menu As Roku
            case 'clearrecent':
                //clearRecentlyWatched
                Router.focusPage()
                app?.clearRecentlyWatched().then(()=>{
                    Router.reload()
                })
                break;
            */
            case 'about':
                this.page.widgets.menu.hideMenu()
                Router.focusWidget('About')
                break;
            case 'menu':
                Router.focusPage();
                Router.focusWidget('Menu')
                break;
            case 'search':
                this.page.widgets.menu.hideMenu()
                Router.focusPage();
                Router.navigate('search-screen/grid', false)
                break;
            case 'similar-videos':
                Router.focusPage();
                this.handleSimilarVideos(videoInfo.node_id)
                break;
            case 'my-queue':
                app?.queueManager.showQueueRow()
                // if(this.page.reloadGrid) {
                //   this.page.reloadGrid()
                // }
                Registry.setTimeout(() => {
                    Router.focusPage();
                }, 100)
                break;
            case 'add-queue':
                this.page.widgets.loadingscreen.showLoadingScreen(true)
                Router.focusPage();
                app?.queueManager.once('added', () => {
                    if (this.page.reloadGrid) {
                        //this.page.reloadGrid()
                        this.page.widgets.loadingscreen.showLoadingScreen(false)
                    }
                })
                app?.queueManager.once('error', (e) => Log.info('OptionsMenu: add-queue error', e))
                //this.page.loading.showLoadingScreen(true)
                app?.queueManager.addToQueue(nodeType, nodeId, videoInfo.title)
                //Router.focusWidget('Loading')
                //const aPage = Router.getActivePage()
                break;
            case 'remove-queue':
                this.page.widgets.loadingscreen.showLoadingScreen(true)
                Router.focusPage();
                app?.queueManager.once('removed', () => {
                    if (this.page.reloadGrid) {
                        //this.page.reloadGrid()
                        this.page.widgets.loadingscreen.showLoadingScreen(false)
                    }
                })
                app?.queueManager.once('error', (e) => Log.info('OptionsMenu: remove-queue error', e))
                //this.page.loading.showLoadingScreen(true)
                app?.queueManager.removeFromQueue(nodeType, nodeId, videoInfo.title);

                break;
            case 'block':
                this.page.widgets.loadingscreen.showLoadingScreen(true)
                app?.blockingManager.once('blocked', () => {
                    if(!isMenuFocused) {
                        this.page.reloadGrid();
                        this.page.widgets.loadingscreen.showLoadingScreen(false)
                    } else {
                        this.page.widgets.menu.updateMenuItem('block');
                        Router.focusWidget('menu')
                        this.page.widgets.menu.loadHome();
                        this.page.widgets.loadingscreen.showLoadingScreen(false)
                    }
                    //bug fixes XFIN-836
                    Router.getActivePage()?.widgets.notification.showNotification(`Successfully blocked !`)
                })
                app?.blockingManager.once('error', (e) => Log.info('OptionsMenu: block error', e))
                if(isMenuFocused) {
                    const menuItem = this.page.widgets.menu.getCurrentFocusedMenu();
                    app?.blockingManager.doAction('block', menuItem);
                } else {
                    Router.focusPage();
                    app?.blockingManager.doAction('block');

                }

                break;
            case 'unblock':
                this.page.widgets.loadingscreen.showLoadingScreen(true)
                app?.blockingManager.once('unblocked', () => {
                    if(!isMenuFocused) {
                        this.page.reloadGrid();
                        this.page.widgets.loadingscreen.showLoadingScreen(false)
                    } else {
                        this.page.widgets.menu.updateMenuItem('unblock');
                        this.page.widgets.loadingscreen.showLoadingScreen(false)
                        Router.focusWidget('menu')
                    }
                    //bug fixes XFIN-836
                    Router.getActivePage()?.widgets.notification.showNotification(`Successfully unblocked !`)
                })
                app?.blockingManager.once('error', (e) => Log.info('OptionsMenu: unblock error', e))
                if(isMenuFocused) {
                    const menuItem = this.page.widgets.menu.getCurrentFocusedMenu();
                    app?.blockingManager.doAction('unblock', menuItem);
                } else {
                    Router.focusPage();
                    app?.blockingManager.doAction('unblock');
                }
                break;
            case 'moreinfo':
                // Router.focusPage();
                this.page.checkBookmarkOrVideoResume(videoInfo, true)
                break;
            case 'parental-control' :
                // Router.focusPage();
                this.page.widgets.menu.hideMenu()
                this.page.widgets.parentalcontrol.showProfile()
                break;
            case 'cc-setting':
                this.page.widgets.menu.hideMenu()
                Router.focusPage();
                Router.navigate('cc-setting/grid', false)
                break;
            case 'clear-Single-Recent':
                Router.focusPage();
                app?.clearRecentlyWatched(nodeId).catch((e) => {
                    Log.info('OptionsMenu: clear-Single-Recent error', e)
                });
                break;
            case 'rate-content':
                this.tag('OptionsMenuPanel').visible = false;
                const ratePanel = this.tag('RateContentPanel');
                ratePanel.setVideoItem(nodeId, likeValue);
                ratePanel.visible = true;
                this._setState('RateContent');
                break;
        }

        // const { appConfig, appState } = AppData as AppSetup
        // const app = appState?.getApp()!
        // const itemType = this.menuItems[this.index].item.menuType
        // switch (itemType) {
        //   case 'l1':
        //     this._updateSelected()
        //     Router.focusPage()
        //     Router.navigate('main-grid-screen/' + this.l1menuCategory[this.index], false)
        //     break;
        //   case 'search':
        //     appConfig.searchInput = appConfig?.defaultSearchInput;
        //     appConfig.useHistory = false;
        //     Router.navigate('search-screen/grid', false)
        //     break;
        // }

    }

    handleSimilarVideos(nodeId) {
        //const { appState } = AppData as AppSetup
        // const app = appState?.getApp()
        // const grid = app?.loadSimilarVideos(nodeId)
        // app?.navigation.continuesStack.push(grid)
        Router.navigate('mlp-grid-screen/similar/' + nodeId + '_'+new Date().getTime, false)
    }

    onIndexChanged(indexData: any) {
        this.index = indexData.index
    }


    override _getFocused():
        | Lightning.Component<Lightning.Component.TemplateSpecLoose, Lightning.Component.TypeConfig>
        | null
        | undefined {
        this.autoPlay?.userInteracted(false)
        Log.info('OptionsMenuWidget: _getFocused fired')
        return this.tag('OptionsMenuList')
    }

    override _focus(): void {
        Log.info('OptionsMenuWidget: _focus fired')
        this.tag('OptionsMenuPanel').visible = true
        this.tag('RateContentPanel').visible = false
        this._showoptionsMenu()
        this.index = this.tag('OptionsMenuList').index
        this.visible = true
        this.setSmooth('alpha', 1)
    }

    override _unfocus(): void {
        Log.info('OptionsMenuWidget: _unfocus fired')
        this.setSmooth('alpha', 0)
        this.visible = false
        Logger.processUserAction('closingOptionsMenuOnGridScreen');
    }

    override _handleBack() {
        Log.info('OptionsMenuWidget: _handleBack fired')
        this.page.widgets.menu.hideMenu()
        /* Fix for XFIN-1062 */
        if(!this.page.hasFocus()){
            Router.focusPage();
        }
        /* Fix for XFIN-1062 */
    }

    override _handleLeft() {
        return true
    }

    override _handleRight() {
        return true
    }

    override _handleUp() {
        return true
    }

    override _handleDown() {
        if (this.index === this.menuItems.length - 1) {
            this._setState('CloseButton')
            return true
        }
        return true
    }

    _showoptionsMenu() {
        const { appState, appConfig } = AppData as AppSetup
        const app = appState?.getApp()
        const appApiConfig = appState?.getAppApiConfig()
        const currGrid: GridViewModel = app?.navigation.getCurrentGrid()!
        const videoInfo = app?.navigation.getCurrentVodInfo()
        this.menuItems = [];
        const recentRow = currGrid.getRowByName('recently watched')
        const currRowList = currGrid.getUiRowAt(currGrid.getFocusInfo().focusRow)
        const isMenuFocused = this.page.isMenuFocused;
        let addedIndex = 0
        this.defaultItems.map((item, index) => {

            let retStatus = true;
            if (!Helper.isCurrentPage(item.page)) {
                retStatus = false
            } else {
                // if (item.id == 'clearrecent') {         // XFIN-1389
                //     if (!recentRow) retStatus = false;
                // }
                if (item.id == 'top') {
                    if (currGrid.getFocusInfo().focusRow == 0) retStatus = false;
                }
                if (item.id == 'startItem') {
                    if (currGrid.getFocusInfo().foucsItem == 0) retStatus = false;
                }

                if (item.id == 'similar-videos') {
                    if (!videoInfo || videoInfo.feed_type != 'video' || videoInfo.actionkey.indexOf('general-') == 0) retStatus = false;
                }

                /*if (item.id == 'moreinfo' || item.id == 'similar-videos') {
                    if (!videoInfo || videoInfo.feed_type != 'video') retStatus = false;
                }*/

                if (item.id == 'moreinfo') {
                    if (videoInfo.actionkey.indexOf('general-') == 0 || (videoInfo.actiontype && videoInfo.actiontype == 'live')) retStatus = false;
                }

                if (item.id == 'my-queue') {
                    if (!appConfig?.enableQueueManagement || (videoInfo.actiontype && videoInfo.actiontype == 'live')) return false
                    const isAvailable = app?.queueManager.isQueueAvailable()!;
                    if (!isAvailable || currRowList.data.item.rowList.name.toLowerCase() == 'queue') {
                        retStatus = false
                    }
                }

                if (item.id == 'add-queue') {
                    if (!appConfig?.enableQueueManagement) return false
                    if (!videoInfo) return false;
                    if ((videoInfo.type && videoInfo.type == 'childapp') || videoInfo.actiontype && videoInfo.actiontype == 'live') return false;
                    if (videoInfo.actionkey && videoInfo.actionkey.indexOf('general') == 0) return false;
                    let nodeType = 'video';
                    let nodeId = videoInfo.node_id;
                    if (videoInfo.node_id == '') {
                        nodeType = 'show';
                        nodeId = videoInfo.id;
                    }
                    const isAdded = app?.queueManager.isAddedToQueue(nodeType, nodeId)!;
                    if (isAdded) {
                        retStatus = false
                        return false;
                    } else {
                        retStatus = true
                    }
                }

                if (item.id == 'remove-queue') {
                    if (!appConfig?.enableQueueManagement) return false
                    if (!videoInfo) return false;
                    if ((videoInfo.type && videoInfo.type == 'childapp') || videoInfo.actiontype && videoInfo.actiontype == 'live') return false;
                    if (videoInfo.actionkey && videoInfo.actionkey.indexOf('general') == 0) return false;
                    let nodeType = 'video';
                    let nodeId = videoInfo.node_id;
                    if (videoInfo.node_id == '') {
                        nodeType = 'show';
                        nodeId = videoInfo.id;
                    }
                    const isAdded = app?.queueManager.isAddedToQueue(nodeType, nodeId)!;
                    if (isAdded) {
                        retStatus = true
                    } else {
                        retStatus = false
                        return false;
                    }
                }

                if (item.id == 'clear-Single-Recent') {
                    const gridTypeKey = currRowList.data.item.rowList.keys
                    if (gridTypeKey.toLowerCase() !== 'hist') {
                        retStatus = false;
                    }
                }

                if (item.id == 'cc-setting' && appConfig.enableCCSettings == false) {
                    retStatus = false
                    return false
                }

                if (item.id == 'block' || item.id == 'unblock') {
                    if (!videoInfo || (videoInfo.type && videoInfo.type == 'childapp') || videoInfo.actiontype && videoInfo.actiontype == 'live') return false;
                    if(!appApiConfig?.appConfig.enableBlockFeature){
                        retStatus = false
                    } else {
                        if(this.page.isMenuFocused){
                            const menuItem = this.page.widgets.menu.getCurrentFocusedMenu();
                            if(!menuItem.canBlock) {
                                return false
                            } else {
                                if(item.id == 'block' && menuItem.channel.blockItem) {
                                    retStatus = false
                                } else if(item.id == 'unblock' && !menuItem.channel.blockItem){
                                    retStatus = false
                                }
                            }
                        } else {
                            if(item.id == 'block' && (videoInfo.blockItem || videoInfo.actionkey.indexOf('general') == 0)) {      /* XFIN-1096 Fix  */
                                retStatus = false
                            } else if(item.id == 'unblock' && !videoInfo.blockItem){
                                retStatus = false
                            }
                        }
                    }
                }

                if(item.id == 'parental-control'){
                    if(!appConfig.enableSocialMediaParentalControl || app?.appApiConfig.appConfig.genre.toLowerCase() !== 'movies') {
                        retStatus = false
                    }
                }

                if(item.id == 'rate-content'){
                    if(!appApiConfig?.appConfig.enableLikeDislike){
                        retStatus = false
                    }
                }
            }



            if (retStatus) {
                this.menuItems.push({
                    w: 650,
                    h: 70,
                    rect: true,
                    collision:true,
                    color: 0x00000000,
                    type: OptionsMenuItem,
                    zIndex: 102,
                    itemIndex:addedIndex,
                    itemSelected: false,
                    item: item
                })
                addedIndex++
            }
        })
        this.tag('OptionsMenuList').reload(this.menuItems)
        Logger.processUserAction('showingOptionsMenuOnGridScreen');
    }

    override _onActivated(page: any) {
        Log.info('OptionsMenuWidget: _onActivated')
        this.page = page
    }


    // _handleHover(target) {
    //     console.log('OptionsWidget _handleHover : ', target)
    //     true
    // }
    $onIndexHover(indexData) {
        this.tag('OptionsMenuList').setIndex(indexData.index)
    }

    _handleClick(target) {
    //    console.log('OptionsWidget _handleClick : ', target)
        if (typeof target?.itemIndex === 'number') {
            this.index = target.itemIndex;
            this.tag('OptionsMenuList').setIndex(target.itemIndex, { immediate: true });
            this.$ItemSelected()
        }
        else if (target && target.ref === 'OptionsMenuPanel') {
            this._setState('');
            this.page.widgets.menu.hideMenu();
            Router.focusPage();
        }
    }

    _onRateContentClose(likeVal: any) {
        this._setState('')
         const { appState } = AppData as AppSetup
        const app = appState?.getApp()
        const grid = app?.navigation.getCurrentGrid()
        this.page.widgets.menu.hideMenu()
        if (likeVal !== undefined && likeVal !== null) {
            grid?.updateItemLikeStatus(likeVal)
        }
        Router.focusPage()
    }

    static override _states(): any[] {
        return [
            class CloseButton extends this {
                override _getFocused() {
                    const { platform } = AppData as AppSetup
                    platform?.textToSpeach("Close")
                    return this.tag('CloseButton')
               }
                override _handleUp() {
                    this._setState('')
                    this.tag('OptionsMenuList').setIndex(this.menuItems.length - 1)
                    return true
                }
                override _handleEnter() {
                    this._setState('')
                    this.page.widgets.menu.hideMenu()
                    Router.focusPage()
                    return true
                }
            },

            class RateContent extends this {
                override _getFocused() {
                    return this.tag('RateContentPanel');
                }

                override _handleBack() {
                    this.tag('RateContentPanel').visible = false;
                    this.tag('OptionsMenuPanel').visible = true;
                    this._setState('');
                    return true;
                }
            }
        ]
    }
}
